<template>
  <div>
    <!-- 新增工具面板 -->
    <a-modal
      :title="title"
      :width="600"
      :visible="visibleSetUp"
      :confirmLoading="confirmLoading"
      okText="保存"
      @ok="handleSubmit"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <a-spin :spinning="confirmLoading">
        <!-- 新增书签表单域 -->
        <a-form :form="form">
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="上级菜单"
            has-feedback
            v-if="type === 1 || type === 3"
          >
            <a-select
              @change="handleChange"
              v-decorator="[
                'parent_id',
                {rules: [{ required: true, message: '请选择分类菜单' }]}
              ]">
              <a-select-option :value="0">作为一级菜单</a-select-option>
              <a-select-option v-for="(item, index) in treeList" :key="index" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="工具名称"
          >
            <a-input
              v-decorator="[
                'name',
                {rules: [{ required: true, message: '输入工具名称' }]}
              ]"
            />
          </a-form-item>

          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="链接地址"
          >
            <a-input
              v-decorator="[
                'link_address',
                {rules: [{ required:false, message: '输入链接地址' }]}
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="缩略图"
          >
            <div class="dropbox">
              <a-upload
                name="img"
                listType="picture-card"
                class="avatar-uploader"
                :showUploadList="false"
                :action="uploadUrl"
                :beforeUpload="beforeUpload"
                @change="handleImgChange"
                v-decorator="[
                  'icon_path',
                  {
                    valuePropName: 'file',
                    getValueFromEvent: normFile,
                  }]"
              >
                <img style="width: 100px; height: 100px;" v-if="imgUrl" :src="imgUrl" alt="avatar"/>
                <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'"/>
                </div>
              </a-upload>
            </div>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { baseUrl } from '@/utils/request'
import api from '@/api/manage'
import pick from 'lodash.pick'
import { createTool, updateTool } from '@/api/manage'

export default {
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      visibleSetUp: false,
      checkNick: false,
      form: this.$form.createForm(this),
      record: {},
      uploadUrl: baseUrl + api.uploadUrl,
      confirmLoading: false,
      loading: false,
      list: [],
      imgUrl: '',
      type: 1,
      title: '新增工具'
    }
  },
  computed: {
    treeList () {
      const tree = []
      this.list.forEach((val, key) => {
        tree.push({
          id: val.id,
          name: val.name
        })
        if (val.children && val.children.length > 0) {
          val.children.forEach((v, k) => {
            tree.push({
              id: v.id,
              name: '├─' + v.name
            })
            // if (v.children && v.children.length > 0) {
            //   v.children.forEach((t, i) => {
            //     tree.push({
            //       id: t.id,
            //       name: '├─├─' + t.name
            //     })
            //   })
            // }
          })
        }
      })
      return tree
    }
  },
  methods: {
    show (list, record, type) {
      this.visibleSetUp = true
      this.$nextTick(() => {
        this.record = record
        this.imgUrl = record.full_path
        if (JSON.stringify(record) !== '{}') {
          this.title = '编辑工具'
        } else {
          this.title = '新增工具'
        }
        this.list = list
        this.type = type
        if (type === 3) {
          this.loadEditInfo(record)
        }
      })
    },
    handleSubmit () {
      this.confirmLoading = true
      this.form.validateFields((errors, values) => {
        if (!errors) {
          // console.log(values, this.type)
          // return false
          const formData = pick(values, ['name', 'link_address', 'icon_path'])
          if (this.type === 1) {
            formData.parent_id = values.parent_id
            this.handleCreateTool(formData)
          } else if (this.type === 2) {
            formData.parent_id = this.record.id
            this.handleCreateTool(formData)
          } else if (this.type === 3) {
            formData.id = this.record.id
            formData.parent_id = values.parent_id
            this.handleUpdateTool(formData)
          }
          // console.log(formData)
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleCreateTool (formData) {
      createTool(formData)
        .then((res) => {
          this.$emit('ok', formData) // 子组件将数据带到父组件
          this.$message.success(res.msg)
          this.form.resetFields()
          this.visibleSetUp = false
          this.imgUrl = ''
        }).catch((e) => this.requestFailed(e))
        .finally(() => {
          this.confirmLoading = false
        })
    },
    handleUpdateTool (formData) {
      updateTool(formData)
        .then((res) => {
          this.$emit('ok', formData) // 子组件将数据带到父组件
          this.$message.success(res.msg)
          this.form.resetFields()
          this.visibleSetUp = false
          this.imgUrl = ''
        }).catch((e) => this.requestFailed(e))
        .finally(() => {
          this.confirmLoading = false
        })
    },
    handleCancel () {
      this.record = {}
      this.form.resetFields()
      this.visibleSetUp = false
      this.loading = false
      this.imgUrl = ''
    },
    loadEditInfo (data) {
      new Promise((resolve) => {
        resolve()
      }).then(() => {
        const formData = pick(data, ['parent_id', 'name', 'link_address', 'icon_path'])
        this.form.setFieldsValue(formData)
      })
    },
    handleChange (value) {
      // console.log(`selected ${value}`)
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        this.$message.error('只支持上传jpg，png图')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2M')
      }
      return (isJPG || isPNG) && isLt2M
    },
    handleImgChange (info) {
      // console.log(info)
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        this.imgUrl = info.file.response.result.full_path
        this.loading = false
        // getBase64(info.file.originFileObj, (imageUrl) => {
        //   this.record.icon_path = imageUrl
        //   this.loading = false
        // })
      }
      if (info.file.status === 'error') {
        this.$message.error(info.file.response.msg)
        this.loading = false
      }
    },
    normFile (e) {
      // console.log('Upload event:', e)
      if (Array.isArray(e)) {
        return e['file']['response']['result']['path']
      }
      if (e.file.status === 'done') {
        return e.file.response.result.path
      }
    },
    requestFailed (err) {
      // console.log(err)
      // console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    }
  }
}
</script>

<style lang="less" scoped>
  .avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>
